"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prodConfig = exports.devConfig = void 0;
exports.devConfig = {
    baseUrl: 'https://api.mvpdev.alphaprep.com/',
    reducerPath: 'alphaPrepApi'
};
exports.prodConfig = {
    baseUrl: 'https://api.alphaprep.com/',
    reducerPath: 'alphaPrepApiProd'
};
